<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow class="col-12 d-flex flex-column justify-content-center align-content-center">
      <div class="col-lg-3 col-5 d-flex justify-content-center align-self-center mb-5">
        <img loading=lazy id="logo-img" src="../assets/logo.svg">
      </div>
      <CCol lg="6" sm="12">
        <CCard class="mb-0">
          <CCardBody>
            <CForm @submit.prevent="handleSubmit">
              <h1>{{ $t('confirmAccount') }}</h1>
              <p class="text-muted">{{ $t('confirmAccountDescription') }}</p>
              <!-- Username -->
              <CInput :placeholder="$t('email')" autocomplete="username email" v-model="username" :is-valid="validator('username', username)">
                <template #prepend-content><CIcon name="cil-user"/></template>
              </CInput>
              <!-- Password -->
              <CInput :placeholder="$t('password')" type="password" autocomplete="curent-password" v-model="password" :invalid-feedback="passwordErrorMsg" :is-valid="validator('password', password)">
                <template #prepend-content><CIcon name="cil-lock-locked"/></template>
              </CInput>
              <!-- Token -->
              <CInput v-show="attemptedSubmit == 'new'" :placeholder="$t('token')" v-model="token" :invalid-feedback="$t('invalidToken')" :is-valid="validator('token', token)">
                <template #prepend-content><CIcon name="cil-file"/></template>
              </CInput>
              <CRow>
                <!-- Request new token -->
                <CCol col="6" class="text-left">
                  <CButton color="link" class="px-0" @click="newTokenRequested">{{ $t('requestNewToken') }}</CButton>
                </CCol>
                <!-- Confirm -->
                <CCol col="6" class="text-right">
                  <CSpinner v-if="loading" variant="success" small></CSpinner>
                  <CButton v-else color="primary" class="px-4" @click="submitClicked">{{ $t('confirm') }}</CButton>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      username: this.$route && this.$route.query && this.$route.query.username ? this.$route.query.username : '',
      password: '',
      token: this.$route && this.$route.query && this.$route.query.token ? this.$route.query.token : '',
      loginError: false,
      requested: false,
      attemptedSubmit: false,
      loading: false
    }
  },
  computed:
  {
    ...mapState({ 
      alertType: state => state.alert.type,
      alertOutput: state => state.alert.output
    }),
    ...mapState('users', ['processTask']),
    ...mapState('users', ['requestConfirmTokenOutput']),
    passwordErrorMsg: function()
    {
      var result = this.$i18n.t('invalidPassword');
      
      if(this.alertOutput)
      {
        if(this.alertOutput['PasswordRequiresDigit']) result = this.alertOutput['PasswordRequiresDigit'];
        if(this.alertOutput['PasswordTooShort']) result = this.alertOutput['PasswordTooShort'];
      }

      return result;
    }
  },
  name: 'ConfirmAccount',
  methods: {
    ...mapActions('users', ['confirmAccount']),
    ...mapActions('users', ['requestConfirmToken']),
    ...mapActions({
        clearAlert: 'alert/clear' 
    }),
    validator(field, val) 
    {
      var result = undefined; // This is the default, in case the user hasn't attemptedSubmit yet

      if(this.attemptedSubmit)
      {
        if(!val) result = false;
        if(result !== false)
        {
          result = !(this.alertOutput && (this.alertOutput['PasswordRequiresDigit'] || this.alertOutput['PasswordTooShort']));
        }
      }

      return result;
    },
    submitClicked: function()
    {
      this.attemptedSubmit = 'confirm';

      const { username, password, token } = this;
      if(username && password && token)
      {
        this.loading = true;
        this.confirmAccount({username, password, token});
      }
    },
    newTokenRequested: function()
    {
      this.attemptedSubmit = 'new';

      if(this.username)
      {
        this.loading = true;
        this.requestConfirmToken(this.username);
      }
    }
  },
  created: function()
  {
    this.clearAlert();
  },
  watch: 
  { 
    alertType: function()
    {
      this.loginError = this.alertType === "alert-danger";
    },
    alertOutput: function()
    {
      this.loginError = this.alertType === "alert-danger";
    },
    username: function()
    {
      this.loginError = false;
    },
    password: function()
    {
      this.loginError = false;
    },
    processTask: function(val)
    {
      if(val != null)
      {
          if(val == false)
          {
            // console.log(this.alertOutput);
            if(this.alertOutput && this.alertOutput["InvalidToken"])
            {
              var result = this.$i18n.t("invalidTokenError");
            }
            else
            {
              var result = this.$i18n.t("confirmAccountError");
            }
          }
          else
          {
            result = this.$i18n.t("confirmAccountSuccess");
          }
          this.loading = false;

          alert(result);
      }
    },
    requestConfirmTokenOutput: function(val)
    {
      if(val != null)
      {
          if(val == false)
          {
            var result = this.$i18n.t("requestConfirmTokenError");
          }
          else
          {
            result = this.$i18n.t("requestConfirmTokenSuccess");
          }
          this.loading = false;

          alert(result);
      }
    }
  }
}
</script>

<style scoped>
#logo-img
{
  max-width: 50vw;
  max-height: 50vh;
}
</style>